import { RingFinishEnum } from '@/app/enums/RingFinishEnum';
import { RingStyleEnum } from '@/app/enums/RingStyleEnum';

import type {
  Gen4RingWizardData,
  WizardCarouselImage,
  WizardCarouselImageContent,
} from './types';

const SIZING_KIT_SIZE_IMG = 'product/wizard/or4-sizing-kit-size.jpg';

const TECH_SPECS_CONTENT: WizardCarouselImageContent[] = [
  {
    copy: null,
    heading: 'fully_titanium_design',
    iconName: 'diamond_boxed',
  },
  {
    copy: null,
    heading: '8_days_battery_life',
    iconName: 'battery_boxed_2024',
  },
  {
    copy: null,
    heading: 'smart_sensing',
    iconName: 'sensing_boxed',
  },
  {
    copy: null,
    heading: 'water_resistant',
    iconName: 'water_drop_boxed',
  },
];

const LIFESTYLE_YOU_LANG_CONTENT: WizardCarouselImageContent[] = [
  {
    copy: null,
    heading: 'optimize_your_sleep',
    iconName: 'bed_boxed',
  },
  {
    copy: null,
    heading: 'understand_your_body',
    iconName: 'readiness_outline_boxed',
  },
  {
    copy: null,
    heading: 'track_your_activity',
    iconName: 'meditation_boxed',
  },
];

const TECH_SPECS_CAROUSEL_IMG: WizardCarouselImage = {
  altMsgKey: 'wizard_tech_specs_image_alt',
  contentTitle: 'wizard_tech_specs_title',
  content: TECH_SPECS_CONTENT,
  contentFormat: 'OR4TechSpec',
  inverseText: true,
  mobileSrc: null,
  originalSrc: 'product/wizard/tech-specs.jpg',
  originalSrcKey: null,
  thumbnailSrc: 'product/wizard/tech-specs.jpg',
};

export const gen4WizardData: Gen4RingWizardData = {
  [RingStyleEnum.OuraRing4]: {
    [RingFinishEnum.Black]: {
      styleStep: null,
      finishStep: {
        carouselImages: [
          {
            altMsgKey: 'product_catalog_color_black_lifestyle',
            contentTitle: null,
            content: LIFESTYLE_YOU_LANG_CONTENT,
            contentFormat: 'OR4YouLang',
            inverseText: true,
            mobileSrc: null,
            originalSrc: 'product/wizard/or4-black-lifestyle-v2.jpg',
            thumbnailSrc: 'product/wizard/or4-black-lifestyle-v2.jpg',
            originalSrcKey: null,
          },
          TECH_SPECS_CAROUSEL_IMG,
          {
            altMsgKey: 'product_catalog_color_black',
            contentTitle: null,
            content: null,
            inverseText: false,
            mobileSrc: 'product/wizard/or4-black.mp4',
            originalSrc: 'product/wizard/or4-black.mp4',
            thumbnailSrc: 'product/wizard/or4-black-profile-thumb.jpg',
            originalSrcKey: null,
          },
          {
            altMsgKey: 'product_catalog_color_black',
            contentTitle: null,
            content: null,
            inverseText: false,
            mobileSrc: null,
            originalSrc: 'product/wizard/or4-black-angle.jpg',
            thumbnailSrc: 'product/wizard/or4-black-angle.jpg',
            originalSrcKey: null,
          },
        ],
        image: null,
        selector: {
          altMsgKey: 'product_catalog_color_black',
          originalSrc: 'product/wizard/or4-black-selector.png',
        },
      },
      sizeStep: {
        carouselImages: null,
        image: {
          altMsgKey: 'product_catalog_color_black',
          inverseText: true,
          originalSrc: SIZING_KIT_SIZE_IMG,
        },
        selector: null,
      },
    },
    [RingFinishEnum.BrushedSilver]: {
      styleStep: null,
      finishStep: {
        carouselImages: [
          {
            altMsgKey: 'product_catalog_color_brushed_silver_lifestyle',
            contentTitle: null,
            content: LIFESTYLE_YOU_LANG_CONTENT,
            contentFormat: 'OR4YouLang',
            inverseText: true,
            mobileSrc: null,
            originalSrc: 'product/wizard/or4-brushed-silver-lifestyle-v2.jpg',
            thumbnailSrc: 'product/wizard/or4-brushed-silver-lifestyle-v2.jpg',
            originalSrcKey: null,
          },
          TECH_SPECS_CAROUSEL_IMG,
          {
            altMsgKey: 'product_catalog_color_brushed_silver',
            content: null,
            contentTitle: null,
            inverseText: false,
            mobileSrc: 'product/wizard/or4-brushed-silver.mp4',
            originalSrc: 'product/wizard/or4-brushed-silver.mp4',
            thumbnailSrc: 'product/wizard/or4-brushed-silver-profile-thumb.jpg',
            originalSrcKey: null,
          },
          {
            altMsgKey: 'product_catalog_color_brushed_silver_angle',
            content: null,
            contentTitle: null,
            inverseText: false,
            mobileSrc: null,
            originalSrc: 'product/wizard/or4-brushed-silver-angle.jpg',
            thumbnailSrc: 'product/wizard/or4-brushed-silver-angle.jpg',
            originalSrcKey: null,
          },
        ],
        image: null,
        selector: {
          altMsgKey: 'product_catalog_color_brushed_silver',
          originalSrc: 'product/wizard/or4-titanium-selector.png',
        },
      },
      sizeStep: {
        carouselImages: null,
        image: {
          altMsgKey: 'product_catalog_color_brushed_silver',
          inverseText: true,
          originalSrc: SIZING_KIT_SIZE_IMG,
        },
        selector: null,
      },
    },
    [RingFinishEnum.Gold]: {
      styleStep: null,
      finishStep: {
        carouselImages: [
          {
            altMsgKey: 'product_catalog_color_gold_lifestyle',
            content: LIFESTYLE_YOU_LANG_CONTENT,
            contentFormat: 'OR4YouLang',
            contentTitle: null,
            inverseText: true,
            mobileSrc: null,
            originalSrc: 'product/wizard/or4-gold-lifestyle-v2.jpg',
            thumbnailSrc: 'product/wizard/or4-gold-lifestyle-v2.jpg',
            originalSrcKey: null,
          },
          TECH_SPECS_CAROUSEL_IMG,
          {
            altMsgKey: 'product_catalog_color_gold',
            content: null,
            contentTitle: null,
            inverseText: false,
            mobileSrc: 'product/wizard/or4-gold.mp4',
            originalSrc: 'product/wizard/or4-gold.mp4',
            thumbnailSrc: 'product/wizard/or4-gold-profile-thumb.jpg',
            originalSrcKey: null,
          },
          {
            altMsgKey: 'product_catalog_color_gold_angle',
            content: null,
            contentTitle: null,
            inverseText: false,
            mobileSrc: null,
            originalSrc: 'product/wizard/or4-gold-angle.jpg',
            thumbnailSrc: 'product/wizard/or4-gold-angle.jpg',
            originalSrcKey: null,
          },
        ],
        image: null,
        selector: {
          altMsgKey: 'product_catalog_color_gold',
          originalSrc: 'product/wizard/or4-gold-selector.png',
        },
      },
      sizeStep: {
        carouselImages: null,
        image: {
          altMsgKey: 'product_catalog_color_gold',
          inverseText: true,
          originalSrc: SIZING_KIT_SIZE_IMG,
        },
        selector: null,
      },
    },
    [RingFinishEnum.Rose]: null,
    [RingFinishEnum.RoseGold]: {
      styleStep: null,
      finishStep: {
        carouselImages: [
          {
            altMsgKey: 'product_catalog_color_rose_gold_lifestyle',
            content: LIFESTYLE_YOU_LANG_CONTENT,
            contentFormat: 'OR4YouLang',
            contentTitle: null,
            inverseText: true,
            mobileSrc: null,
            originalSrc: 'product/wizard/or4-rose-gold-lifestyle-v2.jpg',
            thumbnailSrc: 'product/wizard/or4-rose-gold-lifestyle-v2.jpg',
            originalSrcKey: null,
          },
          TECH_SPECS_CAROUSEL_IMG,
          {
            altMsgKey: 'product_catalog_color_rosegold',
            content: null,
            contentTitle: null,
            inverseText: false,
            mobileSrc: 'product/wizard/or4-rose-gold.mp4',
            originalSrc: 'product/wizard/or4-rose-gold.mp4',
            thumbnailSrc: 'product/wizard/or4-rose-gold-profile-thumb.jpg',
            originalSrcKey: null,
          },
          {
            altMsgKey: 'product_catalog_color_rosegold',
            content: null,
            contentTitle: null,
            inverseText: false,
            mobileSrc: null,
            originalSrc: 'product/wizard/or4-rose-gold-angle.jpg',
            thumbnailSrc: 'product/wizard/or4-rose-gold-angle.jpg',
            originalSrcKey: null,
          },
        ],
        image: null,
        selector: {
          altMsgKey: 'product_catalog_color_rosegold',
          originalSrc: 'product/wizard/or4-rose-selector.png',
        },
      },
      sizeStep: {
        carouselImages: null,
        image: {
          altMsgKey: 'product_catalog_color_rosegold',
          inverseText: true,
          originalSrc: SIZING_KIT_SIZE_IMG,
        },
        selector: null,
      },
    },
    [RingFinishEnum.Silver]: {
      styleStep: null,
      finishStep: {
        carouselImages: [
          {
            altMsgKey: 'product_catalog_color_silver_lifestyle',
            content: LIFESTYLE_YOU_LANG_CONTENT,
            contentFormat: 'OR4YouLang',
            contentTitle: null,
            inverseText: true,
            mobileSrc: null,
            originalSrc: 'product/wizard/or4-silver-lifestyle-v2.jpg',
            thumbnailSrc: 'product/wizard/or4-silver-lifestyle-v2.jpg',
            originalSrcKey: null,
          },
          TECH_SPECS_CAROUSEL_IMG,
          {
            altMsgKey: 'product_catalog_color_silver',
            content: null,
            contentTitle: null,
            inverseText: false,
            mobileSrc: 'product/wizard/or4-silver.mp4',
            originalSrc: 'product/wizard/or4-silver.mp4',
            thumbnailSrc: 'product/wizard/or4-silver-profile-thumb.jpg',
            originalSrcKey: null,
          },
          {
            altMsgKey: 'product_catalog_color_silver',
            content: null,
            contentTitle: null,
            inverseText: false,
            mobileSrc: null,
            originalSrc: 'product/wizard/or4-silver-angle.jpg',
            thumbnailSrc: 'product/wizard/or4-silver-angle.jpg',
            originalSrcKey: null,
          },
        ],
        image: null,
        selector: {
          altMsgKey: 'product_catalog_color_silver',
          originalSrc: 'product/wizard/or4-silver-selector.png',
        },
      },
      sizeStep: {
        carouselImages: null,
        image: {
          altMsgKey: 'product_catalog_color_silver',
          inverseText: true,
          originalSrc: SIZING_KIT_SIZE_IMG,
        },
        selector: null,
      },
    },
    [RingFinishEnum.Stealth]: {
      styleStep: null,
      finishStep: {
        carouselImages: [
          {
            altMsgKey: 'product_catalog_color_stealth_lifestyle',
            content: LIFESTYLE_YOU_LANG_CONTENT,
            contentFormat: 'OR4YouLang',
            contentTitle: null,
            inverseText: true,
            mobileSrc: null,
            originalSrc: 'product/wizard/or4-stealth-lifestyle-v2.jpg',
            thumbnailSrc: 'product/wizard/or4-stealth-lifestyle-v2.jpg',
            originalSrcKey: null,
          },
          TECH_SPECS_CAROUSEL_IMG,
          {
            altMsgKey: 'product_catalog_color_stealth',
            content: null,
            contentTitle: null,
            inverseText: false,
            mobileSrc: 'product/wizard/or4-stealth.mp4',
            originalSrc: 'product/wizard/or4-stealth.mp4',
            thumbnailSrc: 'product/wizard/or4-stealth-profile-thumb.jpg',
            originalSrcKey: null,
          },
          {
            altMsgKey: 'product_catalog_color_stealth_angle',
            content: null,
            contentTitle: null,
            inverseText: false,
            mobileSrc: null,
            originalSrc: 'product/wizard/or4-stealth-angle.jpg',
            thumbnailSrc: 'product/wizard/or4-stealth-angle.jpg',
            originalSrcKey: null,
          },
        ],
        image: null,
        selector: {
          altMsgKey: 'product_catalog_color_stealth',
          originalSrc: 'product/wizard/or4-stealth-selector.png',
        },
      },
      sizeStep: {
        carouselImages: null,
        image: {
          altMsgKey: 'product_catalog_color_stealth',
          inverseText: true,
          originalSrc: SIZING_KIT_SIZE_IMG,
        },
        selector: null,
      },
    },
    [RingFinishEnum.Titanium]: null,
  },
};
